module.exports = __webpack_public_path__ + "img/_54A2230.6ca6de7b.jpg";